import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';

// ─── OrganizationStatusTag ────────────────────────────────────────────────────

const ORGANIZATION_STATUS_COLOR: Record<string, string> = {
  pending: 'orange',
  active: 'green',
  suspended: 'red',
};

export const OrganizationStatusTag = ({ status }: { status: string }) => {
  const t = useTranslate();
  return (
    <Tag color={ORGANIZATION_STATUS_COLOR[status] ?? 'default'}>
      {t(`tenancy.organizations.status.${status}`)}
    </Tag>
  );
};

// ─── OrganizationPublisherStatusTag ───────────────────────────────────────────

const ORGANIZATION_PUBLISHER_STATUS_COLOR: Record<string, string> = {
  scheduled: 'blue',
  active: 'green',
  ended: 'default',
};

export const OrganizationPublisherStatusTag = ({
  status,
}: {
  status: string;
}) => {
  const t = useTranslate();
  return (
    <Tag color={ORGANIZATION_PUBLISHER_STATUS_COLOR[status] ?? 'default'}>
      {t(`tenancy.organizations.publisher_status.${status}`)}
    </Tag>
  );
};

// ─── PaymentMomentTag ─────────────────────────────────────────────────────────

const PAYMENT_MOMENT_COLOR: Record<string, string> = {
  progressive: 'blue',
  upfront: 'purple',
};

export const PaymentMomentTag = ({ moment }: { moment: string }) => {
  const t = useTranslate();
  return (
    <Tag color={PAYMENT_MOMENT_COLOR[moment] ?? 'default'}>
      {t(`tenancy.contracts.payment_moment.${moment}`)}
    </Tag>
  );
};

// ─── OrganizationRoleTag ──────────────────────────────────────────────────────

const ORGANIZATION_ROLE_COLOR: Record<string, string> = {
  owner: 'gold',
  member: 'default',
};

export const OrganizationRoleTag = ({ role }: { role: string }) => {
  const t = useTranslate();
  return (
    <Tag color={ORGANIZATION_ROLE_COLOR[role] ?? 'default'}>
      {t(`tenancy.organizations.role.${role}`)}
    </Tag>
  );
};
